import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { GoogleIcon } from '../../../commons/icons/Google';
import { SocialItem } from './SocialItem';
import { AppleIcon } from '../../../commons/icons/Apple';
import { CustomMUIButton } from '../../../commons/buttons/CustomMUIButton';
import { ButtonClassNames } from '../../../../models/Common';
import { useCustomSnackbar } from '../../../../hooks/useCustomEnqueueSnackbar';

interface AddSocialsFormProps {
  handleSkip: () => void;
  handleNext: () => void;
}

const socials = {
  google: {
    connected: false,
  },
  apple: {
    connected: false,
  },
};

export const AddSocialsForm: FC<AddSocialsFormProps> = ({ handleSkip, handleNext }) => {
  const { customEnqueueSnackbar } = useCustomSnackbar();
  const { t } = useTranslation();
  const handleClick = () => {
    customEnqueueSnackbar('add social', 'info');
  };
  return (
    <div className="add-socials-form">
      <div className="add-socials-form__socials">
        <SocialItem
          buttonLabel={socials.google.connected ? t('common.connected') : t('buttons.connect')}
          handleClick={handleClick}
          icon={<GoogleIcon className="icon" size="big" />}
          infoText={`${t('registration.loginWith')} Google`}
          isDisabled={socials.google.connected}
        />
        <SocialItem
          buttonLabel={socials.apple.connected ? t('common.connected') : t('buttons.connect')}
          handleClick={handleClick}
          icon={<AppleIcon className="icon" size="big" />}
          infoText={`${t('registration.loginWith')} Apple ID`}
          isDisabled={socials.apple.connected}
        />
      </div>
      <div className="add-socials-form__btn-group">
        <CustomMUIButton
          label={t('common.skip')}
          handleClick={handleSkip}
          className={ButtonClassNames.SecondaryOutlined}
        />
        <CustomMUIButton
          label={t('buttons.continue')}
          handleClick={handleNext}
          className={ButtonClassNames.PrimaryFulfilled}
        />
      </div>
    </div>
  );
};
